<div
  *ngIf="isOpen"
  class="fixed inset-0 z-[999] flex items-center justify-end"
  (keydown.escape)="close()"
>
  <!-- Backdrop -->
  <div
    class="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
    (click)="close()"
  ></div>

  <!-- Panel: floating modal with larger margins and border -->
  <div class="relative mr-10 my-10 w-[calc(100vw-256px-80px)] h-[calc(100vh-80px)] bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden">

    <!-- Header: entity selected → only back button + close -->
    <div *ngIf="selectedEntity" class="flex items-center gap-3 px-6 py-4 border-b border-gray-100 bg-white shrink-0">
      <button
        pButton
        icon="pi pi-arrow-left"
        class="p-button-rounded p-button-text p-button-secondary bg-white shadow-sm border border-gray-200 w-10 h-10 hover:bg-gray-50"
        (click)="back()"
        pTooltip="Back"
        tooltipPosition="right"
        tooltipStyleClass="custom-tooltip"
      ></button>

      <button
        type="button"
        class="ml-auto flex items-center justify-center w-8 h-8 rounded-full text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all focus:outline-none"
        (click)="close()"
        pTooltip="Close"
        tooltipPosition="left"
        tooltipStyleClass="custom-tooltip"
      >
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>

    <!-- Header: grid view → title + close -->
    <div *ngIf="!selectedEntity" class="flex items-center gap-4 px-8 py-5 border-b border-gray-100 bg-white shrink-0">
      <div class="flex flex-col">
        <h2 class="text-2xl font-bold text-gray-800 m-0 leading-tight">All Entities</h2>
        <span class="text-xs text-gray-400 font-medium mt-0.5">Browse entities from other modules</span>
      </div>

      <button
        type="button"
        class="ml-auto flex items-center justify-center w-8 h-8 rounded-full text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all focus:outline-none"
        (click)="close()"
        pTooltip="Close"
        tooltipPosition="left"
        tooltipStyleClass="custom-tooltip"
      >
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>

    <!-- Content area -->
    <div class="flex-1 overflow-y-auto relative">

      <!-- Entity Selector Grid -->
      <div *ngIf="!selectedEntity" class="px-8 pt-6 pb-8">
        <!-- Search input — full width, auto-focused -->
        <div class="relative mb-6">
          <i class="pi pi-search absolute left-4 top-1/2 -translate-y-1/2 text-[var(--primary-500)] text-sm"></i>
          <input
            #searchInput
            type="text"
            [(ngModel)]="searchText"
            placeholder="Search entities..."
            class="w-full pl-11 pr-4 py-3 text-sm border border-gray-300 rounded-xl bg-white outline-none ring-0 focus:border-2 focus:border-gray-500 focus:py-[11px] focus:pl-[43px] focus:pr-[15px] transition-colors"
          />
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          <button
            *ngFor="let entity of availableEntities"
            type="button"
            class="flex flex-col items-center gap-3 p-5 rounded-xl border border-gray-200 bg-white hover:border-[var(--primary-500)] hover:bg-[var(--primary-500)]/5 hover:shadow-md transition-all group cursor-pointer"
            (click)="selectEntity(entity)"
          >
            <div class="w-12 h-12 rounded-xl bg-gray-50 border border-[var(--primary-500)]/30 group-hover:bg-[var(--primary-500)]/10 group-hover:border-[var(--primary-500)] flex items-center justify-center transition-all">
              <i [class]="entity.icon + ' text-xl text-[var(--primary-500)]/60 group-hover:text-[var(--primary-500)] transition-colors'"></i>
            </div>
            <span class="text-xs font-bold text-gray-600 group-hover:text-[var(--primary-500)] text-center transition-colors leading-tight">
              {{ entity.label }}
            </span>
            <span class="text-[10px] text-gray-400 group-hover:text-[var(--primary-400)] tracking-wide transition-colors">
              {{ entity.displayModule }}
            </span>
          </button>
        </div>
      </div>

      <!-- Loading State (absolute overlay so ng-container stays in DOM) -->
      <div
        *ngIf="loadingEntity"
        class="absolute inset-0 flex items-center justify-center bg-white"
      >
        <div class="flex flex-col items-center gap-4">
          <i class="pi pi-spin pi-spinner text-3xl text-[var(--primary-500)]"></i>
          <span class="text-sm text-gray-400 font-medium">Loading {{ selectedEntity?.label }}...</span>
        </div>
      </div>

      <!-- Dynamic Component Host — always in DOM so ViewChild resolves correctly -->
      <ng-container #entityHost></ng-container>
    </div>
  </div>
</div>
